import React from 'react';
import Grid from '@mui/material/Grid';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import { SelectModal } from '../../SelectModal';
import AssessmentIcon from '@mui/icons-material/Assessment';


const styles = {
    root: {
        minHeight: '32px',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
    },
    text: {
        padding: '0 12px',
    },
    button: {
        padding: 0,
        margin: '4px'
    }
}

interface IMonitoringStatusChipProps {
    filterName: string,
    onSelect: (filterName: string, value: any) => void,
    title: string,
    client: string,
    currentSelection?: any,
    show: boolean,
    removeFilter?: (filter: string, names: string[]) => void;
    filterFlag: string;
    filterNames: string[];
    view?: string;
    showOnReport?: boolean;
}

export default function MonitoringStatusChip({ showOnReport, filterName, onSelect, title, client, currentSelection, show, removeFilter, filterFlag, filterNames, view }: IMonitoringStatusChipProps) {

    let options = ["Not Started", "In Progress", "Completed"];

    if (view === "Feedback") {
        options = ["In Progress", "Completed"];
    }

    const handleSelect = (name: any, value: any) => {
        onSelect(name, value);
    }

    const handleDelete = () => {
        if (removeFilter !== null && removeFilter !== undefined) {
            removeFilter(filterFlag, filterNames);
        }
    }

    return (
        <>
            {show &&
                <Grid>
                    <Grid container sx={styles.root} justifyContent="space-between" alignItems="center">
                        {showOnReport &&
                            <AssessmentIcon sx={{ ml: 1 }} />
                        }
                        <Grid sx={styles.text}>
                            <Typography variant="body1">{title}</Typography>
                        </Grid>
                        <SelectModal title={title} filterName={filterName} mutliSelect={false} currentSelection={currentSelection} onSelect={handleSelect} options={options} searchable={true} />
                        <Grid>
                            {removeFilter !== null && removeFilter !== undefined ?
                                <IconButton title="Remove" aria-label="Remove" onClick={handleDelete} sx={styles.button}><CancelIcon /></IconButton> : <React.Fragment />}
                        </Grid>
                    </Grid>
                </Grid>
            }
        </>
    )
}